import "./experience.css";

const Experience = (props) => {
  return (
    <div ref={props.experienceSection} className="experiences">
      <h3>Experience</h3>
      <ul>
        <li className="experience">
          <div className="experience-list">
            <div className="experience-info">
              <div className="designation">
                <h5>Software Engineer</h5>
                <span className="at-text">@</span>
                <div className="company-links">
                  <a
                    href="https://mple.ai/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Mple AI
                  </a>
                  <span
                    className="period"
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    {" "}
                    (March 2025 - Present)
                  </span>
                </div>
              </div>
              <p>
                • Progressed from diverse client projects at Code B Solutions to
                leading development on mple.ai, the company’s flagship
                AI-powered product, while continuing to support legacy systems.
                <span className="br" />
                • Leading product development at mple.ai, a flagship AI-powered
                platform, from concept to production
                <span className="br" />
                • Engineered 5–6 full-stack features across NestJS, Next.js/
                React.js, and Python.
                <span className="br" />
                • Architected and deployed a scalable microservices
                infrastructure across AWS (Lambda, SQS, CloudWatch, SNS, S3,
                IAM, SES) and GCP (Cloud Run, GCS, VPC) with 99% uptime.
                <span className="br" />
                • Built dual RAG pipelines: custom implementation with MongoDB
                and Xenova/Transformers for contextual search, and cloud-native
                RAG leveraging GPT's internal knowledge bases.
                <span className="br" />
                • Integrated multiple LLMs (OpenAI, Anthropic, Hugging Face
                Transformers) to enable advanced NLP and adaptive AI workflows
                <span className="br" />
                • Built AI agents with tool-calling capabilities to automate
                tasks.
                <span className="br" />
                • Built and managed end-to-end WhatsApp communication workflows
                — including category-based templates, automated API messaging,
                and interactive WhatsApp Flows
                <span className="br" />• Engineered and refined LLM prompts to
                generate accurate, contextually relevant AI responses with
                measurable quality improvements.
              </p>
              <ul>
                <li>Node.js</li>
                <li>NestJS</li>
                <li>MongoDB</li>
                <li>Python</li>
                <li>AWS</li>
                <li>GCP</li>
                <li>RAG Systems</li>
                <li>OpenAI API</li>
                <li>ffmpeg</li>
                <li>MySQL</li>
                <li>React.js</li>
                <li>Next.js</li>
                <li>WhatsApp Automation (API & Flows)</li>
                <li>Event Driven Architecture</li>
                <li>Microservices</li>
              </ul>
              <div className="designation" style={{ marginTop: "24px" }}>
                <h5>Software Engineer</h5>
                <span className="at-text">@</span>
                <div className="company-links">
                  <a
                    href="https://code-b.dev/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Code B Solutions
                  </a>
                  <span
                    className="period"
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    (March 2024 - March 2025)
                  </span>
                </div>
              </div>
              <p>
                • Developed robust backend APIs and services using NestJS for
                scalable enterprise solutions
                <span className="br" />
                • Deployed and managed applications on AWS EC2 with Nginx
                reverse proxy configuration
                <span className="br" />
                • Designed and optimized MySQL databases for high-performance
                data operations
                <span className="br" />• Contributed to frontend development
                with ReactJS for seamless user experiences
              </p>
              <span className="br" />
              <ul>
                <li>NestJS</li>
                <li>MySQL</li>
                <li>React.js</li>
                <li>AWS</li>
                <li>React.js</li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Experience;
